import React from 'react';
import MembershipOverview from '../MembershipOverview/MembershipOverview';
// import OrganizationOverview from '../OrganizationOverview/OrganizationOverview';
import InvoiceOverview from '../InvoiceOverview/InvoiceOverview';
import CommitteeOverView from '../CommitteeOverView/CommitteeOverView';
// import MyEvents from '../MyEvents/MyEvents';
import Magazine from '../Magazine/Magazine';
import AccountOverview from '../AccountOverview/AccountOverview';
import MembershipNotification from '../MembershipNotification/MembershipNotification';
import './UserDashboardPage.scss';
import { auth } from '../../../../../services';
import { getUserInvitations, getUserCommittees } from '../../../../../Redux/Actions/EndUser/AccountDetailsActions';
import { connect } from 'react-redux';
import CircularProgress from '@material-ui/core/CircularProgress';

class UserDashboardPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
    };

    //console.log(props);
  }
  componentDidMount() {
    this.props.getUserInvitations(auth.getAuthUserId());
    this.props.getUserCommittees(auth.getAuthUserId());
  }


  render() {

    return (
      <div className="dash-container">
        <div className="dash-body">
          <h1 className="pt-3 pb-3">Dashboard</h1>
          <div className="row cols">
            <div className="col-md-4 col-sm-12 col-left">
              <div>
                <AccountOverview />
              </div>
              {this.props.userInvitations ? (this.props.userInvitations.length > 0 ?
                <div>
                  <MembershipNotification />
                </div>
                : "") : ""}
              <div>
                <MembershipOverview />
              </div>

              <div>
                <InvoiceOverview />
              </div>
              {/*<div>
								<OrganizationOverview />
							</div>*/}
            </div>
            <div className="col-md-8 col-sm-12 col-right">
              {/*<div>
								<MyEvents />
                            </div>*/}
              {this.props.userCommittees ? (this.props.userCommittees.length > 0 ?
                <div>
                  <CommitteeOverView />
                </div>
                : "") : ""}
              <div>
                <Magazine />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    loading: state.authentication.loading,
    userInvitations: state.accountDetails.userInvitations,
    userCommittees: state.accountDetails.userCommittees
  };
}

export default connect(mapStateToProps, {
  getUserInvitations,
  getUserCommittees
})(UserDashboardPage);